import { Dayjs } from "dayjs";
import { BaseRewardCalculationInformation } from "../types/actionModule/rewardCalculationInformation";
import { EmployeeIncentivation } from "../types/employeeScores";
import { CallResult, doApiGet, doApiPatch, doApiPost } from "./Requests";

export interface ActionModuleInstanceIncentivationRequest {
  employeeUserId: string;
  instanceId: number;
  rewardCalculationInformation: BaseRewardCalculationInformation;
}

export const incentivationUsersApi = {
  getUsers: () =>
    doApiGet("/api/companies/current/employees")
      .then(res => res.result)
      .catch(error => console.log(error)),

  editMultipleInstancesIncentivate: (actionModuleId: number, request: ActionModuleInstanceIncentivationRequest[]) =>
    doApiPatch<ActionModuleInstanceIncentivationRequest[], any>(
      `/api/companies/current/actionmodules/${actionModuleId}/incentivation`,
      request
    ),

  importEmployeeScoresAction: (
    actionModuleId: number,
    employeeScores: EmployeeIncentivation[],
    startDate: Dayjs,
    endDate: Dayjs
  ): Promise<CallResult<unknown>> =>
    doApiPost(`/api/companies/current/actionmodules/${actionModuleId}/import?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`, employeeScores),
};
